module.exports = {
  content: ['./src/**/*.{js,jsx,ts,tsx}'],
  theme: {
    extend: {
      colors: {
        'os-text-primary': '#2C2C2D',
        'content-primary': '#2C2C2D',
        'content-secondary': '#57585A',
        'content-subdued': '#C5C5C6',
        'os-black': '#2C2C2D',
        'os-light-gray': '#C5C6C6',
        'os-blue': '#027CFF',
        caroured50: '#FF2636',
        'stroke-boundary': '#F0F1F1',
        'stroke-input': '#C5C5C6',
        'os-light-blue-25': '#D2E4F740',
        'os-blank-background': '#F0F1F1',
        'os-blank-background-20': '#F0F1F133',
        'os-border': '#C5C5C6',
        'white-75': '#FFFFFFBF',
        'tag-bg': '#F0F1F1',
      },
      lineHeight: {
        4.5: '1.125rem',
        5.5: '1.375rem',
        11: '3rem',
      },
      fontSize: {
        '4.2xl': '2.375rem',
      },
      margin: {
        'header-height': '68px',
      },
      boxShadow: {
        menu: '0px 8px 13px 0px #2C2C2D45',
        card: '0px 3px 10px 0px #2C2C2D12, 0px 0px 0px 1px #2C2C2D12',
        'nav-button': '0px 8px 12px 0px #2C2C2D45',
      },
      backgroundImage: {
        'category-active':
          'linear-gradient(0deg, #FFFFFF, #FFFFFF), linear-gradient(0deg, rgba(240, 241, 241, 0.2), rgba(240, 241, 241, 0.2))',
      },
    },
  },
  variants: {},
  plugins: [],
};
